import planetsMethods from './Planets'

export const PlanetServices = {
  ...planetsMethods
}

export * from './Planets.types'
